const OrderHelpDefaults = {
  showPreviousOrderDays: 30,
  maxNoOfOrders: 0,
  statusForOrdersNotShown: () => [],
  pageName: '',
};
Object.freeze(OrderHelpDefaults);
export default OrderHelpDefaults;